<template>
    <BreadCrumb PageTitle="Modifier une validation queue" />
    <EditValidationQueue />
</template>

<script lang="ts">
import { defineComponent } from "vue";

import BreadCrumb from "../../components/Common/BreadCrumb.vue";
import EditValidationQueue from "@/components/ValidationQueue/EditValidationQueue.vue";

export default defineComponent({
    name: "EditValidationQueuePage",
    components: {
        BreadCrumb,
        EditValidationQueue,
    },
});
</script>